import Vue from "vue";

import App from "./App.vue";
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
import VueCookies  from "vue-cookies";
import store from "./store";
import MaterialKit from "./plugins/material-kit";
import Locale from "./services/locale"
// Vue.config.productionTip = false;
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.use(VueCookies);
Vue.use(MaterialKit);
Vue.prototype.$menuId = '';
Vue.mixin({
  methods: {
    localeLabel(label) {
      return Locale.localeText(label);
    },
    notifyVue(type = "default", text) {
      if (!text) {
        if (type === "success") {
          text = "Changes have been saved!";
        } else if (type === "danger") {
          text = "Action failed!";
        }
      }
      this.$notify({
        timeout: 2500,
        message: text,
        icon: "add_alert",
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: type
      });
    }
  }
});

new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router,
  beforeCreate() {
		this.$store.commit('initialiseStore');
	}
});
